import { TypedPrices } from '../types';
import { FilteredPriceBreakdownConfig } from '../redux/priceBreakdownReducer';

export const getPriceAmount = (prices: TypedPrices[], type: string) => {
  return prices?.find((element) => element?.type === type)?.amount || null;
};

export const shouldShowFinalPrice = (
  breakdownConfig: FilteredPriceBreakdownConfig,
  typedPrices: TypedPrices[],
  hideFinalPriceLogic: boolean,
) => {
  // if final Price is not enabled in CFM, do not show final price
  if (!breakdownConfig?.final?.isEnabled) return false;
  const finalPrice = getPriceAmount(typedPrices, 'final');
  const regularPrice = getPriceAmount(typedPrices, 'regular');
  // If Hide Final Price Logic is enabled in CFM
  // AND if Final Price is equal to the Regular Price, then Final Price field must be hidden from the front-end.
  if (hideFinalPriceLogic && regularPrice && regularPrice === finalPrice) return false;
  // If there is no final Price data and also text override is disabled in CFM for final Price
  // Then do not show final price
  if (!finalPrice && !breakdownConfig?.final?.hasTextOverride) return false;
  return true;
};

export const getVisiblePricesCount = (
  breakdownConfig: FilteredPriceBreakdownConfig,
  isUsedVehicle: boolean,
  displayRebates: boolean,
  displayRebatesUsed: boolean,
  rebateLength: number,
  typedPrices: TypedPrices[],
  showFinalPrice: boolean,
) => {
  // Count Number of price options that are enabled and also have a price amount
  const enabledPriceOptionsCount = Object.keys(breakdownConfig).reduce((count, key) => {
    const item = breakdownConfig[key as keyof FilteredPriceBreakdownConfig];
    // if item is not enabled in CFM skip
    if (!item.isEnabled) return count;
    const itemAmount = typedPrices?.find((element) => element?.type === item?.priceKey);
    const hasNoAmount = !itemAmount || !itemAmount?.amount;
    const isOverrideEnabled = item?.hasTextOverride;
    // if item price is not available from BE data and text override is not enabled in CFM then SKIP
    if (hasNoAmount && !isOverrideEnabled) return count;
    // if item is final Price and we're not going to show final price then skip
    if (item.priceKey === 'final' && !showFinalPrice) return count;
    return count + 1;
  }, 0);

  const isRebateEnabledInCFM = isUsedVehicle ? displayRebatesUsed : displayRebates;
  const rebatesCount = rebateLength && isRebateEnabledInCFM ? rebateLength : 0;
  return enabledPriceOptionsCount + rebatesCount;
};
